export const colors = {
  orange: "#ff7d1f",
  blue: "#1B3865",
  green: "#4cb050",
  blueBackground: "#BDEDFB",
  text: "#262626",
  headerBlueBackgound: "#425e8a",
  headerValueText: "#454545",
  btnDisable: "#b1bcbe",
  lightText: "#b4b4b4",
  white: "#ffffff",
  whiteSmoke: "#f5f9fa",
  grey: "#d5d5d5",
  black: "#000000",
  headerBackgound: "#d9d9d9",
  imgBackground: "#ffe9dc",
  // sidebarFormHeading: "#fff4ee",
  // sidebarFormHeading: "#ebf9ff",
  sidebarFormHeading: "#f5f9fa",
  plusbtnBackground: "#fca984",
  greyHeader: "#919191",
  blue2: "#2da3e6",
  blue3: "#8ebad4",
  grey2: "#DDDDDD",
};

export const URL = {
  login: "/",
  patientDetails: "/patientDetails",
  instruction: "/instruction",
  visit: "/visits",
  hypoglycemia: "/hypoglycemia",
  form: "/form",
  bloodsugarrecord: "/bloodsugarrecord",
  savedRecords: "/savedRecords",
};

export const apiURL = {
  sendVerification: () => `SendVerificationCodeNew`,
  sendeProCode: () => `GetSubjectDetailsByePROCode`,
  verifyOTP: () => `VerifyVerificationCodeForMobile`,
  visitDetailsBySubjectId: () => `GetVisitSchedulerBySubjectId`,
  subjectDetailsByMobileNo: () => `GetSubjectDetailsByMobileNo`,
  updateLanguage: () => `UpdateLanguageType`,
  pageStatus: () => `GetPagestatusByVisitId`,
  submitData: () => `SaveSubmitPageData`,
  instruction: () => `GetStudyInstructions`,
  getSavedData: () => `GetSavedSubjectDetailsBySubjectId`,
  updateFormData: () => `UpdatePageData`,
};
